import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { withAccount } from '../../components/AccountContext';
import { intlShape } from '../../components/prop-types';

const i18n = defineMessages({
  add: { id: 'menu.new_commercial_agreement', defaultMessage: 'Add Agreement' },
});

class CommercialAgreementListHeader extends Component {
  constructor(props) {
    super(props);
    this.navigateToCreation = this.navigateToCreation.bind(this);
  }

  navigateToCreation() {
    const { history, currentAccount } = this.props;
    const redirectLink = `/accounts/${currentAccount}/commercial-agreements/new`;
    history.push(redirectLink);
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const addLabel = formatMessage(i18n.add);
    return (
      <React.Fragment>
        <div className="p-grid">
          <div className="p-col align-right">
            <Button icon="pi pi-plus" type="button" label={addLabel} onClick={this.navigateToCreation} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

CommercialAgreementListHeader.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default withAccount(withRouter(injectIntl(CommercialAgreementListHeader)));
